// import MemberInvite from "~/models/MemberInvite";
// import StudyTeam from "~/models/StudyTeam";
import Team from "~/models/Teams";
import type { TeamConstructorArgs } from "~/models/Teams";
// import ContactData from "~/models/ContactData";
// import Address from "~/models/Address";
import Invite, { type InviteInput } from "~/models/Invites";
// import Proposals from "~/models/Proposals";
// import Reviews from "~/models/Reviews";
import Client, { type ClientInput } from "~/models/Client";
import Post, { type PostInput } from "~/models/Post";

export default defineNuxtPlugin(() => {
  return {
    provide: {
      models: {
        // MemberInvite: (memberInvite: any) =>
        //   new MemberInvite({ ...memberInvite, vueApp }),
        Team: (team: Omit<TeamConstructorArgs, 'app'>) => new Team(team),
        // StudyTeam: (studyTeam: any) => new StudyTeam({ ...studyTeam, vueApp }),
        // ContactData: (contactData: any) => new ContactData({ ...contactData, vueApp }),
        // Address: (address: any) => new Address({ ...address, vueApp }),
        // Invites: (allInvites: any) => new Invites({ ...allInvites, vueApp }),
        Invites: (invite: InviteInput) => new Invite(invite),
        // Proposals: (proposals: any) => new Proposals({ ...proposals, vueApp }),
        // Reviews: (reviews: any) => new Reviews({ ...reviews, vueApp }),
        Client: (client: ClientInput) => new Client(client),
        Post: (post: PostInput) => new Post(post),
      },
    },
  };
});
